// Components
import { Input } from "components"

// Form
import { Controller, useFormContext } from "react-hook-form"

// Types
import type { FormType } from "../utils"

export function Cheque(): JSX.Element {
  // Form
  const { control } = useFormContext<FormType>()

  return (
    <Controller
      name="no_cheque"
      control={control}
      render={({ field, fieldState }) => (
        <Input
          {...field}
          label="CC | DEBIT NO | CHEQUE NO"
          error={fieldState.error?.message}
        />
      )}
    />
  )
}